// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PVideocameraAddOutlinedSvg from "@fishx/icons-svg/es/asn/PVideocameraAddOutlined";
import FishxIcon from '../components/FishxIcon';

var PVideocameraAddOutlined = function PVideocameraAddOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PVideocameraAddOutlinedSvg
  }));
};

PVideocameraAddOutlined.displayName = 'PVideocameraAddOutlined';
export default React.forwardRef(PVideocameraAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PVideocameraAddOutlined.js
// module id = 3727
// module chunks = 0